import React from 'react';
import { useIntl } from 'react-intl';

import Icon from '@/components/Base/Icon';
import { getMainPageUrl } from '@/utils';

import { Button } from './BackToCatalog.styles';

function BackToCatalog() {
  const { formatMessage } = useIntl();

  return (
    <Button alt={formatMessage({ id: 'backToCatalog' })} to={getMainPageUrl()}>
      <Icon width="5" name="arrowLeft" />

      {formatMessage({ id: 'backToCatalog' })}
    </Button>
  );
}

export default BackToCatalog;
